import PropTypes from 'prop-types';
import AlignmentCount from "./ConnectedAlignmentCount.js";
import OutcomeSDKComponent from "./OutcomeSDKComponent.js";
export default OutcomeSDKComponent(AlignmentCount, {
  alignmentSetId: PropTypes.string.isRequired
});